module.exports = __webpack_public_path__ + "static/media/sports-coach.665c910d.svg";